<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "transaction",
  data() {
    return {};
  },
  created() {}
};
</script>
